import { cva } from '@vizit/theme';

const containerClasses = cva({
  base: 'flex flex-col gap-16',
});

const gridClasses = cva({
  base: ['grid gap-x-8 gap-y-4', 'grid-cols-[repeat(auto-fill,118px)]', '[&_.bg-gray-utility-50]:bg-gray-light-25'],
});

const dividerClasses = cva({
  base: 'w-px min-h-[163px] shrink-0 bg-[#D5D7DA]',
});

export { containerClasses, dividerClasses, gridClasses };
